import React from 'react';
import Slider from 'react-slick';
import './GoogleReviews.css';

const reviews = [
  {
    id: 1,
    name: "archi AI",
    date: "Il y a 2 jours",
    rating: 5,
    text: "Expérience absolument parfaite avec FLIP MY CAR. Un grand merci à Thibaut et Arthur pour leur professionnalisme et leur efficacité. Du début à la fin irréprochable, à l’écoute, disponibles, cordiaux et toujours de bons conseils. Je recommande à 100 % sans hésiter."
  },
  {
    id: 2,
    name: "Sylvain Breton",
    date: "Il y a 3 jours",
    rating: 5,
    text: "Une expérience absolument parfaite du début à la fin ! Chaque rendez-vous a été un vrai plaisir : l’équipe est professionnelle, à l’écoute et a su répondre à toutes mes questions avec clarté et efficacité. Ils sont extrêmement disponibles et très réactifs à la moindre demande. La prise en charge est totale : tout est géré de A à Z, notamment l’administratif, ce qui apporte un vrai confort et une grande tranquillité d’esprit. Je recommande cette société de vente de véhicules à 100 % les yeux fermés !"
  },
  {
    id: 3,
    name: "Glad",
    date: "Il y a 1 semaine",
    rating: 5,
    text: "Très bonne expérience avec FLIP MY CAR. Nous étions au départ très retissant car nous devions effectuer notre achat à distance (vivant à l'étranger) et ce n'était pas possible de réserver par un acompte. Après la visite du véhicule par un de nos amis, nous nous sommes finalement décidés à effectuer notre achat à distance et n'avons pas été déçus. La livraison a pu se faire à notre hôtel le lendemain de notre arrivée en France, comme demandé. Après 4 mois d'utilisation, nous sommes très satisfait de notre véhicule, il répond à tout ce que nous souhaitions. Très bon rapport qualité-prix. Merci à l'équipe de FLIP MY CAR."
  },
  {
    id: 4,
    name: "Louis Edgar Ebao Carette",
    date: "Il y a 1 mois",
    rating: 5,
    text: "Transaction fluide, véhicule en parfait état et conforme à l’annonce. Équipe disponible, réactive et professionnelle du début à la fin. Une expérience simple et efficace, sans mauvaise surprise."
  },
  {
    id: 5,
    name: "Sylvain Rocca",
    date: "Il y a 2 mois",
    rating: 5,
    text: "Merci a Thibaut et Arthur pour leur réactivité et leur disponibilité. J'\u00e9tait initialement méfiant âpres avoir trouver l'annonce de ma BMW 330e a un prix très attractif. Finalement Ils on été très professionnel et le véhicule correspondait parfaitement au description faite sur l'annonce. Apres 5 mois d'utilisation du véhicule rien a signaler. Vous pouvez donc faire totalement confiance a FLIP MY CAR et y aller les yeux fermer ! Merci a vous deux et bonne continuation :)"
  },
  {
    id: 6,
    name: "Damien Blanc",
    date: "Il y a 3 mois",
    rating: 5,
    text: "Je voulais remercier Thibaut et Arthur pour l’achat de mon A3. Ils sont vraiment compétents, attentionnés et à l’écoute. Je recommande à 100%. Tout s’est passé très rapidement, même pour la carte grise, et la voiture était tel que dans l’annonce et en très bonne état."
  },
  {
    id: 7,
    name: "Fabien Thezenas",
    date: "Il y a 4 mois",
    rating: 5,
    text: "Très professionnel. Je recommande 👍"
  },
  {
    id: 8,
    name: "Gaelle Moi",
    date: "Il y a 9 mois",
    rating: 5,
    text: "Achat de ma fiat 500x. Tout s'est super bien passé. Merci à Arthur pour toutes les étapes pour l'achat de cette superbe voiture. Service parfait. Je recommande FLIP MY CAR"
  },
  {
    id: 9,
    name: "Chucu 3",
    date: "Il y a 9 mois",
    rating: 5,
    text: "Super experience ! J'ai réussi a revendre un véhicule sous LOA avec eux. Tout a été tres simple et rapide. Ils facilitent vraiment la transaction. Vous pouvez leur faire confiance les yeux fermés."
  },
  {
    id: 10,
    name: "Chloé Finaud",
    date: "Il y a 11 mois",
    rating: 5,
    text: "Équipe professionnelle, toujours présente pour répondre aux questions. Toutes les procédures sont faites en bonne et due forme. Je n'aurais pas pu trouver meilleure voiture, je suis ravie ! Je recommande vivement ! Merci à vous"
  },
  {
    id: 11,
    name: "Stephane Erny",
    date: "Il y a 11 mois",
    rating: 5,
    text: "Très bonne équipe rien a dire véhicule parfait, carte grise à la date, comme prévue je recommande"
  },
  {
    id: 12,
    name: "Pat B",
    date: "Il y a 1 an",
    rating: 5,
    text: "Arthur et Thibault, Nous tenons à vous faire part de notre entière satisfaction suite à l'achat de notre véhicule polo 6 vw chez vous. Celle-ci correspond parfaitement aux photos et vidéos présentées, et nous n'avons eu aucune mauvaise surprise lors de la livraison. L’état du véhicule est conforme à ce qui avait été montré, et il répond pleinement à nos attentes. Nous vous remercions pour votre professionnalisme, la qualité de votre service, ainsi que pour votre transparence tout au long du processus. Nous recommandons vivement votre entreprise et nous n'hésiterons pas à revenir vers vous pour de futurs besoins. Ça fait du bien de voir des jeunes motivés ! Nous avons fait 400 km et on ne regrette pas ! Patrick et Cécile"
  },
  {
    id: 13,
    name: "Ghazi Aouachri",
    date: "Il y a 1 an",
    rating: 5,
    text: "Je suis content de mon expérience avec FlipMyCar. L'acquisition de mon véhicule Q3 s'est déroulée sans accroc, de la première prise de contact à la livraison. L'équipe a été professionnelle, à l'écoute et très réactive. Je recommande vivement cette startup à toute personne cherchant un service de qualité et une expérience client irréprochable. Merci encore à Thibaut et Arthur !"
  },
  {
    id: 14,
    name: "Giuliano Don Papa",
    date: "Il y a 1 an",
    rating: 5,
    text: "Professionnels, réactifs et a l écoute. Essai d un Renault Scenic 4 le samedi livraison le samedi suivant. Arthur et Thibault gèrent la nouvelle carte grise virement sécurisé. En résumé un service a la hauteur de mes attentes du coup 5 étoiles méritées. Bonne continuation. Julien WÜEST"
  },
  {
    id: 15,
    name: "Lydia B",
    date: "Il y a 1 an",
    rating: 5,
    text: "Véhicule Link & Co acheté en Juillet. Allez y les yeux fermés! Le professionnalisme de Thibault et de son collègue fait toute la différence!! Méfiante au début, tous les engagements donnés par Flip My Car ont été respectés, de la carte grise au suivi post vente... Merci énormément et j espere une longue reussite a cette start up!!"
  }
];

const GoogleReviews = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, i) => (
      <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#FBBC05" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
      </svg>
    ));
  };

  return (
    <div className="google-reviews-section">
      <div className="reviews-header">
        <h2 className="reviews-title">ILS NOUS ONT FAIT <span className="highlight-green">CONFIANCE</span></h2>
        <p className="reviews-subtitle">Découvrez les avis certifiés de nos clients sur Google.</p>
        <div className="google-rating-badge">
            <span className="google-g">G</span>
            <div className="rating-info">
                <span className="rating-score">5.0</span>
                <div className="rating-stars">
                    {renderStars(5)}
                </div>
            </div>
        </div>
      </div>

      <div className="reviews-carousel-container">
        <Slider {...settings}>
          {reviews.map((review) => (
            <div key={review.id} className="review-card-wrapper">
              <div className="review-card">
                <div className="review-header">
                  <div className="reviewer-avatar">
                    {review.name.charAt(0)}
                  </div>
                  <div className="reviewer-info">
                    <h4 className="reviewer-name">{review.name}</h4>
                    <span className="review-date">{review.date}</span>
                  </div>
                  <div className="google-icon-small">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.35 11.1H12.18V13.83H17.45C17.2 15.17 16.49 16.13 15.57 16.72V19.12H18.68C20.5 17.44 21.54 14.97 21.54 12.08C21.54 11.74 21.51 11.41 21.45 11.1H21.35Z" fill="#4285F4"/>
                        <path d="M12.18 21.45C14.81 21.45 17.02 20.58 18.68 19.05L15.57 16.65C14.7 17.23 13.59 17.58 12.18 17.58C9.64 17.58 7.49 15.87 6.72 13.57H3.51V16.06C5.17 19.36 8.54 21.45 12.18 21.45Z" fill="#34A853"/>
                        <path d="M6.72 13.57C6.52 12.99 6.42 12.37 6.42 11.73C6.42 11.09 6.52 10.47 6.72 9.89V7.4H3.51C2.84 8.73 2.46 10.2 2.46 11.73C2.46 13.26 2.84 14.73 3.51 16.06L6.72 13.57Z" fill="#FBBC05"/>
                        <path d="M12.18 5.88C13.61 5.88 14.89 6.37 15.9 7.33L18.75 4.48C17.02 2.87 14.81 1.92 12.18 1.92C8.54 1.92 5.17 4.01 3.51 7.31L6.72 9.8C7.49 7.5 9.64 5.88 12.18 5.88Z" fill="#EA4335"/>
                    </svg>
                  </div>
                </div>
                <div className="review-stars">
                  {renderStars(review.rating)}
                </div>
                <p className="review-text">"{review.text}"</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default GoogleReviews;
